import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { PATHS } from 'Config/Routing/paths'
import DesignManagement from '../../Containers/DesignManagement/DesignManagement'
import UploadDesign from '../../Containers/DesignManagement/UploadDesign'
import DesignEditor from '../../Containers/DesignManagement/DesignEditor'

const DesignManagementRouter = props => {
  // const isDesignManagementEnabled = true
  // authorization.isDesignManagementEnabled()

  return (
    <Switch>
      <Route
        exact
        path={PATHS.main.dashboard + PATHS.dashboard.designManagement}
        render={routeProps => <DesignManagement {...routeProps} />}
      />
      <Route
        exact
        path={
          PATHS.main.dashboard +
          PATHS.dashboard.designManagement +
          PATHS.designManagement.upload
        }
        render={routeProps => <UploadDesign {...routeProps} />}
      />
      <Route
        path={
          PATHS.main.dashboard +
          PATHS.dashboard.designManagement +
          PATHS.designManagement.design
        }
        render={routeProps => <DesignEditor {...routeProps} />}
      />
    </Switch>
  )
}

export default withRouter(DesignManagementRouter)
